import React, { useState } from 'react';
import { setEmployeeTemporaryPassword } from './employeeAuth';

export default function EmployeeTemporaryPassword({ company, employee }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false), [message, setMessage] = useState(''), [error, setError] = useState(false);
  const [showForm, setShowForm] = useState(false);
  async function save() {
    if (!window.confirm(`Set a temporary password for ${employee.email}? Any existing password and employee portal sessions will be replaced. Share it securely; no email will be sent.`)) return;
    setBusy(true); setMessage(''); setError(false);
    try {
      await setEmployeeTemporaryPassword(company.id, employee.id, password);
      setPassword('');
      setMessage('Temporary password set. Share the email, portal address and temporary password securely. The employee must choose a new password at first sign-in.');
    } catch (error) { setError(true); setMessage(error.message); }
    finally { setBusy(false); }
  }
  return <div style={{ marginTop:12 }}>
    <button type="button" className="btn btn-ghost btn-sm" aria-expanded={showForm} disabled={busy || !employee.email || employee.is_active === false} onClick={() => { setShowForm(value => !value); setPassword(''); setMessage(''); }}>{showForm ? 'Hide temporary password' : 'Set temporary password (no email)'}</button>
    {showForm && <div style={{ marginTop:10 }}>
      <label style={{ display:'block', fontSize:12, color:'#334155' }}>Temporary password
        <input type="password" autoComplete="new-password" className="config-input" value={password} onChange={event => setPassword(event.target.value)} minLength={12} disabled={busy} placeholder="At least 12 characters"/>
      </label>
      <p style={{ fontSize:12, color:'#475569', lineHeight:1.5 }}>Works without email or company DNS setup. Share this password securely before leaving this form. The employee must replace it at first sign-in.</p>
      <button type="button" className="btn btn-primary btn-sm" disabled={busy || Array.from(password).length < 12} onClick={save}>{busy ? 'Saving…' : 'Set temporary password'}</button>
    </div>}
    {message && <p role={error ? 'alert' : 'status'} style={{fontSize:12,lineHeight:1.5,color:error?'#b91c1c':'#166534'}}>{message}</p>}
  </div>;
}
